/******************************************** STYLING *********************************************/
const s = require('./status-badge.scss');

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';
import {switchExpr} from 'mad-utils/lib/shared';

/**************************************** PROJECT MODULES *****************************************/
import {translate} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
export type DoseStatuses = 'okay' | 'warning' | 'overdue' | 'ignored' | 'future';

interface StatusBadgeProps {
    children?: any;
    className?: string;
    status: DoseStatuses;
}

/********************************************* EXPORT *********************************************/
/**
 * Display a pill-shaped status badge - with text indicating OK, warning, overdue,
 * ignored, or future; and a representative colour (e.g. a red shade for overdue)
 */
export const StatusBadge = (props: StatusBadgeProps) => {
    const {status, className} = props;

    // prettier-ignore
    const bgColourCssClass = switchExpr(
        status === `overdue`, `bg-overdue`,
        status === `future`,  `bg-future`,
        status === `ignored`, `bg-ignored`,
        status === `warning`, `bg-warning`,
        status === `okay`,    `bg-received`,
                              ``
    );

    return (
        <div className={cn(s[`status-badge`], `maxh-25`, `ta-center`, bgColourCssClass, className)}>
            {props.children ||
                (status === 'okay' && translate(`up_to_date`).toUpperCase()) ||
                (status === 'warning' && translate(`upcoming`).toUpperCase()) ||
                (status === 'overdue' && translate(`overdue`).toUpperCase())}
        </div>
    );
};

StatusBadge.displayName = `StatusBadge`;
